// Module
var code = `<div class="flex items-center justify-between">
	<ol class="breadcrumb text-truncate" data-bind="foreach: breadcrumbs">
		<li class="breadcrumb-item" data-bind="css: { active: (\$index() == \$root.breadcrumbs().length-1) }">
			<!-- ko if: (\$index() == \$root.breadcrumbs().length-1) -->
			<span data-bind="text: \$data.friendlyTitle"></span>
			<!-- /ko -->
			<!-- ko if: (\$index() < \$root.breadcrumbs().length-1) -->
			<a data-bind="attr: { href: hash }, text: \$data.title"></a>
			<!-- /ko -->
		</li>
	</ol>

	<div class="flex gap-2">
		<!-- ko if: \$data.buttonsSecondary && \$data.buttonsSecondary().length > 0 -->
		<div class="btn-group dropdown">
			<button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown">Actions</button>
			<ul class="dropdown-menu dropdown-menu-right" data-bind="foreach: buttonsSecondary">
				<!-- ko if: \$data.component -->
				<li data-bind="react: \$data, attr: \$data.attr"></li>
				<!-- /ko -->
				<!-- ko ifnot: \$data.component -->
				<li data-bind="css: { 'dropdown-divider': \$data.divider }">
					<!-- ko ifnot: \$data.divider -->
					<a class="dropdown-item" href="#" data-bind="
						html: \$data.html,
						click: function(){
							if(ko.utils.unwrapObservable(\$data.disabled)) return;

							\$data.click();
						},
						css: { disabled: \$data.disabled }">
					</a>
					<!-- /ko -->
				</li>
				<!-- /ko -->
			</ul>
		</div>
		<!-- /ko -->

		<!-- ko if: \$data.buttonsGroup && \$data.buttonsGroup().length > 0 -->
		<div class="btn-group" data-bind="foreach: buttonsGroup">
			<button class="btn btn-secondary" data-bind="css:{ disabled: \$data.disabled, active: \$data.active }, click: \$data.click, html: \$data.html"></button>
		</div>
		<!-- /ko -->

		<!-- ko if: \$data.buttonsMain && \$data.buttonsMain().length > 0 -->
		<!-- ko foreach: \$data.buttonsMain -->
		<!-- ko if: \$data.component -->
		<div class="btn-group" data-bind="react: \$data, attr: \$data.attr"></div>
		<!-- /ko -->

		<!-- ko if: !\$data.component -->
		<button-extra params="disabled: (\$data.disabled?\$data.disabled:(\$data.isBusy || false)), click: function(data, e){ \$data.click(\$data, e); }, busy: \$data.isBusy || false, html: \$data.html, css: (\$data.css || 'btn btn-primary'), id: \$data.id, icon: \$data.icon, actions: \$data.actions" style="line-height: 0">
		</button-extra>
		<!-- /ko -->

		<!-- /ko -->
		<!-- /ko -->
	</div>
</div>
`;
// Exports
export default code;